"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSidePanelBodyScroll = void 0;
var _react = require("react");
var _HBSidePanel = require("../HBSidePanel.consts");
var useSidePanelBodyScroll = exports.useSidePanelBodyScroll = function useSidePanelBodyScroll() {
  var bodyContainerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var container = bodyContainerRef.current;
    if (!container) {
      return;
    }
    var panel = container.closest(".".concat(_HBSidePanel.SIDE_PANEL_CLASS));
    if (!panel) {
      return;
    }
    var onScroll = function onScroll() {
      if (container.scrollTop > 0) {
        panel.classList.add(_HBSidePanel.SIDE_PANEL_SCROLLED_CLASS);
      } else {
        panel.classList.remove(_HBSidePanel.SIDE_PANEL_SCROLLED_CLASS);
      }
    };
    onScroll();
    container.addEventListener('scroll', onScroll, {
      passive: true
    });
    return function () {
      return container.removeEventListener('scroll', onScroll);
    };
  }, []);
  return {
    bodyContainerRef: bodyContainerRef
  };
};
//# sourceMappingURL=useSidePanelBodyScroll.js.map